import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { AttributeComponent } from '../../interfaces/attribute.component';
import { AttributeDefinition } from '../../models/attribute-definition';
import { FormControl, FormGroup } from '@angular/forms';
import { AttributeControlService } from '../../attribute-control-service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-textbox',
  templateUrl: './textbox.component.html',
  styleUrls: ['./textbox.component.scss']
})
export class TextboxComponent implements OnInit, OnDestroy, AttributeComponent {
  @Input() formGroup: FormGroup;
  @Input() attributeDefinition: AttributeDefinition;

  private readonly destroyed$ = new Subject<void>();

  constructor(
    public _attributeControlService: AttributeControlService<string | null>
  ) { }

  ngOnInit(): void {
    const initial = this.normalize(this.attributeDefinition.value);
    this._attributeControlService.addFormControl(
      this.attributeDefinition.formControlName,
      this.attributeDefinition.isRequired,
      initial,
      this.formGroup
    );
    this.control.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(v => {
        const nv = this.normalize(v);
        if (nv !== v) {
          this.control.setValue(nv, { emitEvent: false });
        }
      });
  }

  get control(): FormControl {
    return this.formGroup.get(this.attributeDefinition.formControlName) as FormControl;
  }

  getErrorMessage(): string {
    if (!this.control) return '';
    if (this.control.hasError('required')) return `${this.label} is required.`;

    if (this.control.hasError('matDatepickerParse') || this.control.hasError('ngxMatDatetimePickerParse')) {
      return `Invalid ${this.label.toLowerCase()}.`;
    }
    return '';
  }

  get label(): string {
    return (this.attributeDefinition?.name || '').replace(/\s*[:*]+$/, '').trim();
  }

  value(): string {
    const val = this.control?.value ?? null;
    this.attributeDefinition.value = val;
    return val;
  }

  private normalize(v: any): string | null {
    if (v === null || v === undefined) return null;
    const s = String(v).trim();
    return s === '' ? null : s;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._attributeControlService.removeControl(this.attributeDefinition.formControlName, this.formGroup);
  }
}
